import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CustomersService } from '../../core/services/customer/customers.service';
import { CurrentUserService } from '../../core/services/user/current-user.service';
import { ActiveCategories } from '../../core/models/active-categories.model';
import { DashboardCategoriesModel } from '../../core/models/dashboard-categories.model';
import { environment } from '../../../environments/environment';
import { StatusUtils } from '../../utils/status-utils';
import { AuthService } from '../../core/services/user/auth.service';
import { UserSessionModel } from '../../core/models/user/current-user.model';
import { TwoFactorAuthStatus } from '../../enums/two-factor-auth.enum';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

declare var KTMenu: any;
@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent {
  constructor(
    private currentUserService: CurrentUserService,
    private customersService: CustomersService,
    private authService: AuthService,
    private translate: TranslateService,
    private router: Router
  ) {}
  twoFactorAuthStatus = TwoFactorAuthStatus;
  currentUser: UserSessionModel | null = null;
  categories: DashboardCategoriesModel[] = [];
  activeCategories: ActiveCategories[] = [];
  statusClass: string = '';
  statusText: string = '';

  ngAfterViewInit(): void {
    if (KTMenu) {
      KTMenu.createInstances();
    }
  }

  ngOnInit(): void {
    this.currentUser = this.currentUserService.GetSession();
    this.translate
      .get([
        'osasAnalysis',
        'dermatology',
        'cardiology',
        'diabetesTracking',
        'settings',
      ])
      .subscribe((translations) => {
        this.categories = [
          {
            name: translations['osasAnalysis'],
            code: 'OSAS',
            image:
              'https://cdn.builder.io/api/v1/image/assets/TEMP/9c8742a9e840b4cbe2fcb20463cde2d0861c6b15f437671dc882d63538fd6b86?placeholderIfAbsent=true&apiKey=83d381f3414f4eb7aab2ad418c3f45ba',
            bgColor: 'bg-peach',
            link: `${environment.apiLocations.osas}`,
          },
          {
            name: translations['dermatology'],
            code: 'DERM',
            image:
              'https://cdn.builder.io/api/v1/image/assets/TEMP/131981b6192ca52501da56a6806e8dc4758584186c40487c870f261bbf8db0c7?placeholderIfAbsent=true&apiKey=83d381f3414f4eb7aab2ad418c3f45ba',
            bgColor: 'bg-light-blue',
            link: `${environment.apiLocations.derm}`,
          },
          {
            name: translations['cardiology'],
            code: 'CARDIOLOGY',
            image:
              'https://cdn.builder.io/api/v1/image/assets/TEMP/a045ba0be7e8348a2bb551c1fa1a1b957a4659bc70cb1f5b982133462c20a73d?placeholderIfAbsent=true&apiKey=83d381f3414f4eb7aab2ad418c3f45ba',
            bgColor: 'bg-light-yellow',
            link: 'http://localhost:4203/',
          },
          {
            name: translations['diabetesTracking'],
            code: 'DIAB',
            image:
              'https://cdn.builder.io/api/v1/image/assets/TEMP/fda94c266e1e7dc0229f14cedf2e12d65befb94d7d9964501d7b730a438869be?placeholderIfAbsent=true&apiKey=83d381f3414f4eb7aab2ad418c3f45ba',
            bgColor: 'bg-light-pink',
            link: `${environment.apiLocations.diab}`,
          },
          {
            name: translations['settings'],
            code: 'BACKOFFICE',
            image:
              'https://cdn.builder.io/api/v1/image/assets/TEMP/9ce6dee2ebe1d5b992adb28bab5f0f0a35b4962167539c9f8cc7fd99403f29fc?placeholderIfAbsent=true&apiKey=83d381f3414f4eb7aab2ad418c3f45ba',
            bgColor: 'bg-light-green',
            link: `${environment.apiLocations.backOffice}`,
          },
        ];
      });
    this.statusClass = StatusUtils.getUserStatusClass(
      this.currentUser?.status ?? 0
    );
    this.statusText = StatusUtils.getUserStatusText(
      this.currentUser?.status ?? 0
    );
    this.getApplicationsByCustomerCode();
  }

  getApplicationsByCustomerCode() {
    this.customersService
      .getApplicationsByCustomerCode(this.currentUser?.customerCode ?? '')
      .subscribe({
        next: (res) => {
          var isLogin = localStorage.getItem('isLogin');
          if (res.length == 1 && isLogin == 'false') {
            localStorage.setItem('isLogin', 'true');
            //derm
            if (this.categories[1].code == res[0].applicationCode) {
              window.location.href = environment.apiLocations.derm;
            }
            //osas
            else if (this.categories[0].code == res[0].applicationCode) {
              window.location.href = environment.apiLocations.osas;
            }
            //diabet
            else if (this.categories[3].code == res[0].applicationCode) {
              window.location.href = environment.apiLocations.diab;
            }
            //backoffice
            else if (this.categories[4].code == res[0].applicationCode) {
              window.location.href = environment.apiLocations.backOffice;
            }
          }
          this.activeCategories = res;
        },
      });
  }

  isCategoryActive(code: string): boolean {
    if (code === 'BACKOFFICE' && this.currentUser?.role === 'Admin') {
      return true;
    }

    const isCategoryInActive = this.activeCategories.some(
      (category) => category.applicationCode === code
    );

    if (code === 'BACKOFFICE') {
      return false;
    }

    return isCategoryInActive;
  }

  signOut() {
    this.authService.logout().subscribe(() => {
      localStorage.setItem('isLogin', 'false');
    });
  }
}
